import React, { Suspense } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import Cookies from 'js-cookie';
import { ADMIN_COOKIE_ACCESS } from '@moxie/constants';
import { Spin } from 'antd';

const AdminLogProtectedRoute = ({
  component: Component,
  ...rest
}: RouteProps | any): any => {
  return (
    <Route
      {...rest}
      render={(props) =>
        Cookies.get(ADMIN_COOKIE_ACCESS) ? (
          <Redirect to="/dashboard" />
        ) : (
          <Suspense
            fallback={
              <div className="page-load">
                <Spin />
              </div>
            }
          >
            <Component {...props} />
          </Suspense>
        )
      }
    />
  );
};

export { AdminLogProtectedRoute };
